import { render, staticRenderFns } from "./MarketplaceStopSyncCreatePage.vue?vue&type=template&id=580d874c&scoped=true&"
import script from "./MarketplaceStopSyncCreatePage.vue?vue&type=script&lang=ts&"
export * from "./MarketplaceStopSyncCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d874c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
